import React, { useEffect } from 'react';
import { storeOauthToken } from '../../../../base/utils';

const EverNoteSuccess=()=> {


  const storeData = async ()=> {await storeOauthToken(); }
  
  useEffect(()=> {
    storeData();
    
  },[]);
 return (
   <>
     
   </>
    )
}
export default EverNoteSuccess;